import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

export const sti: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/05/13/principle/b-50-sti.svg`,
        },
      },
      styles: {
        padding: "3%",
      },
    },
  },
];

export const d50: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/05/13/principle/b-50-d50.svg`,
        },
      },
      styles: {
        padding: "3%",
      },
    },
  },
];

export const t30: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/05/13/principle/b-50-t30.svg`,
        },
      },
      styles: {
        padding: "3%",
      },
    },
  },
];
